import React from 'react'
import remark from 'remark'
import parse from 'remark-parse'
import remarkToreact from 'remark-react'
import remarkAttr from 'remark-attr'

import { useFooter } from '../../../src/hooks/use-footer'

function Footer() {
  const [node] = useFooter()
  const content = node.node.frontmatter.content

  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-line">
          <span className="footer-content">
            {remark()
              .use(parse)
              .use(remarkAttr)
              .use(remarkToreact)
              .processSync(content).contents}
          </span>

          <span className="separator">•</span>

          <a href="/units">For Rent</a>
          <span className="separator">•</span>
          <a href="/sell">For Sale</a>
        </div>
      </div>
    </footer>

  )
}

export default Footer
